jQuery( document ).ready( function($) {

	const swiper = new Swiper( '.banner-swiper', {
		loop: true,
		effect: 'fade',
		speed: 500,
		autoplay: {
			delay: 6000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});

	const swiper2 = new Swiper('.swiper-multi', {
		loop: true,
		watchOverflow: true,
		slidesPerView: 1,

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		// Responsive breakpoints
		breakpoints: {
			640: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		}
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( 'body' ).toggleClass( 'noscroll' );
		$( '.navigation' ).toggleClass( 'shown' );
	});

	// Splash page
	setTimeout( function() {
		$( '.splash' ).trigger( 'click' );
	}, 1200);

	$( window ).scroll( function() {
		$( '.splash' ).trigger( 'click' );
	});

	$( '.splash' ).on( 'click', function() {
		var $this = $( this );
		$this.addClass( 'slideup' );
	});

	// Changing the defaults
	window.sr = ScrollReveal({ 
		// 'bottom', 'left', 'top', 'right'
		origin: 'top',
		distance: '100px',
		duration: 800,
		delay: 0,
		rotate: { x: 0, y: 0, z: 0 },
		opacity: 0,
		scale: 1,
		easing: 'ease',
		container: window.document.documentElement,
		mobile: true,
		reset: false,
		useDelay: 'always',
		// viewFactor: 0.5,
		viewOffset: { top: 100, right: 0, bottom: 0, left: 0 },
		beforeReveal: function (domEl) {},
		beforeReset: function (domEl) {},
		afterReveal: function (domEl) {},
		afterReset: function (domEl) {}
	});

	// Customizing a reveal set

	sr.reveal('.sR-bottom', { origin: 'bottom' });
	sr.reveal('.sR-left', { origin: 'left' });
	sr.reveal('.sR-right', { origin: 'right' });

	sr.reveal('.sR1', { origin: 'bottom', duration: 800, delay: 0, rotate: { x: 0, y: 0, z: 0 }, distance: "75px" });
	sr.reveal('.sR2', { origin: 'bottom', duration: 800, delay: 200, rotate: { x: 0, y: 0, z: 0 }, distance: "75px" });
	sr.reveal('.sR3', { origin: 'bottom', duration: 800, delay: 400, rotate: { x: 0, y: 0, z: 0 }, distance: "75px" });
	sr.reveal('.sR4', { origin: 'bottom', duration: 800, delay: 600, rotate: { x: 0, y: 0, z: 0 }, distance: "75px" });

});